module.exports = __webpack_public_path__ + "img/v4_h3.2b4ec7f9.png";